import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Provider } from 'jotai';
import { createSelector } from 'reselect';
import { SummaryContainer } from '@components/summary-panel';
import { MetricsChartContainer as HzMetricsChartContainer } from '@components/metrics-panel-hz';
import { ErrorBoundary, PageTitle, Footer, TimePanel } from '@components/common';
import { TAB_TRENDS_KEY, DATE_SHORTCUTS, SAVE_SERVICE_DASHBOARD_KEYS } from '@utils/constants';
import { changeCollapseStatus } from '@store/common/actions';
import { clearModifyComparison } from '@store/comparison/actions';
import featureNames from '@utils/featureToggle/constants';
import RetryContext from '@src/contexts/retryContext';
import { ContentWrapper, HzMetricsPanelWrapper } from './styled';
import DimensionContainer from '@components/dimension-panel-hz';
import { showDiagChartSelector } from '@store/dimensionContainer/selectors';
import MetricFilterBar from '@components/summary-panel/MetricFilterBar';
import { trendsShareConfig } from '@components/share/utils';
import InitShare from '@components/share/InitShare';
import { savingSelector } from '@store/trends/dashboard/selectors';
import { getPageKeyForSaveService } from '@utils/savedDashboard';
import InitSave from '@components/saving/InitSave';
import WidgetPanelContainer from '@components/top-widget-panel';
import { isCDNAccountSelector } from '@store/common/selectors';
import AlertPanel from '@components/alert-panel';
import ZenPanel from '@components/zen';
import { buildDashboardStore } from '@src/atoms/utils';
import CompareFiltersBar from '@components/summary-panel/CompareFiltersBar';
import { checkFeature } from '@utils/platform/features/checkFeature';

const defaultStore = buildDashboardStore();

class Main extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    const { clearModifyComparison: clearModify } = this.props;
    clearModify();
  }

  render() {
    const {
      isSharing,
      match,
      interval,
      rtOnTrends,
      savingState,
      isCDNAccount,
      isSavedDashboard = false, // added from savedDashboardHOC
      savedDashboardCreatorId, // added from savedDashboardHOC
      store = defaultStore,
      title = 'Trends',
    } = this.props;

    // force new trends
    // code cleanup will done in a future release
    const horizontalLayout = true;

    const liveModeSelected = rtOnTrends && interval.shortcut === DATE_SHORTCUTS.last15Mins;

    const id = get(match, 'params.id', TAB_TRENDS_KEY); // default home page is trends

    const pageTypeForSaveService = isSavedDashboard
      ? 'saved'
      : isSharing
        ? 'sharing'
        : SAVE_SERVICE_DASHBOARD_KEYS.TRENDS;

    const pageKeyForSaveService = getPageKeyForSaveService(
      pageTypeForSaveService,
      id,
      SAVE_SERVICE_DASHBOARD_KEYS.TRENDS,
    );

    return (
      <Provider store={store}>
        <>
          <RetryContext.Provider value={{ interval }}>
            <ErrorBoundary>
              <PageTitle text={title} />
              <TimePanel />
              <SummaryContainer
                isSharing={isSharing}
                isSavedDashboard={isSavedDashboard}
                pageKeyForSaveService={pageKeyForSaveService}
                savingState={savingState}
                id={id}
                liveModeSelected={liveModeSelected}
                savedDashboardCreatorId={savedDashboardCreatorId}
              />
              <CompareFiltersBar />

              {checkFeature('trends.sections.summary', !isCDNAccount) ? (
                <WidgetPanelContainer />
              ) : null}

              <ContentWrapper layout={horizontalLayout}>
                <MetricFilterBar />

                <HzMetricsPanelWrapper>
                  <AlertPanel />
                  <HzMetricsChartContainer />
                </HzMetricsPanelWrapper>

                <DimensionContainer />
                <InitShare config={trendsShareConfig} />
                <InitSave
                  pageMeta={{
                    page: {
                      key: pageKeyForSaveService,
                    },
                  }}
                />
              </ContentWrapper>
              <ZenPanel />
              <Footer />
            </ErrorBoundary>
          </RetryContext.Provider>
        </>
      </Provider>
    );
  }
}

const selector = createSelector(
  (store) => store.common,
  showDiagChartSelector,
  savingSelector,
  isCDNAccountSelector,
  (common, showDiagChart, savingState, isCDNAccount) => ({
    profiles: common.profiles,
    interval: common.interval,
    collapseStatus: common.collapseStatus,
    newTrendsLayout: common.features[featureNames.NEW_TRENDS_LAYOUT],
    // horizontalLayout: common.layout === LAYOUT_MAP.horizontal,
    rtOnTrends: common.features[featureNames.RT_ON_TRENDS_LAST_15],
    showDiagChart,
    savingState,
    isCDNAccount,
  }),
);

export default connect(selector, {
  triggerAction: changeCollapseStatus,
  clearModifyComparison,
})(Main);

Main.defaultProps = {
  isSharing: false,
  match: {},
  collapseStatus: {},
};
